'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Edition = function Edition(_ref) {
  var edition = _ref.edition,
      _ref$separator = _ref.separator,
      separator = _ref$separator === undefined ? ' | ' : _ref$separator;

  if (edition) {
    return _react2.default.createElement(
      'span',
      { className: 'cp-edition' },
      separator,
      edition
    );
  }

  return null;
};

Edition.propTypes = {
  edition: _react.PropTypes.string.isRequired,
  separator: _react.PropTypes.string
};

exports.default = Edition;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-edition/lib/components/Edition.component.js
// module id = 1478
// module chunks = 1